export default __webpack_public_path__ + "static/media/watch.6e15397c.jpg";